<template>
  <v-bottom-sheet v-model="internalShow" content-class="cs-sheet">
    <v-card class="cs-card" dark>
      <div class="cs-frame-tl"></div>
      <div class="cs-frame-tr"></div>

      <div class="cs-header">
        <span>Comments</span>
        <button class="cs-close" @click="closeSheet">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      <v-card-text class="cs-body">
        <CommentsView :postID="postID" :collection-name="collectionName" />
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import CommentsView from "@/views/CommentsView.vue";

export default {
  components: { CommentsView },
  props: {
    postID: String,
    show: Boolean,
    // Which top-level collection this post actually lives in — chapter
    // discussion posts live in "posts", Explore recommendations and travel
    // plans live in "explore". Defaults to "posts" to preserve existing
    // chapter-post behavior for any caller that doesn't pass this.
    collectionName: { type: String, default: "posts" },
  },
  emits: ["close"],
  data() {
    return {
      internalShow: this.show,
    };
  },
  watch: {
    show(val) {
      this.internalShow = val;
    },
    internalShow(val) {
      if (!val) this.$emit("close");
    },
  },
  methods: {
    closeSheet() {
      this.internalShow = false;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Montserrat:wght@300;400;500;600&display=swap');

:deep(.cs-sheet) { box-shadow: none; }
.cs-card {
  background: #0a0a0b !important;
  border-top: 1px solid rgba(210,175,100,0.25) !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  border-radius: 0 !important;
  position: relative;
  max-height: 85vh;
  overflow-y: auto;
  font-family: 'Montserrat', sans-serif !important;
}
.cs-frame-tl, .cs-frame-tr { position: absolute; top: -1px; width: 16px; height: 16px; pointer-events: none; z-index: 2; }
.cs-frame-tl { left: -1px; border-top: 1px solid rgba(210,175,100,0.6); border-left: 1px solid rgba(210,175,100,0.6); }
.cs-frame-tr { right: -1px; border-top: 1px solid rgba(210,175,100,0.6); border-right: 1px solid rgba(210,175,100,0.6); }

.cs-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 24px 28px 18px;
  font-family: 'Cormorant', serif; font-size: 24px; font-weight: 400;
  color: #edeae2;
  border-bottom: 1px solid rgba(210,175,100,0.1);
}
.cs-close {
  background: none; border: none; cursor: pointer;
  color: rgba(237,232,223,0.3); display: flex; align-items: center;
  transition: color 0.2s; padding: 4px;
}
.cs-close:hover { color: rgba(210,175,100,0.7); }
.cs-close svg { width: 18px; height: 18px; }

.cs-body { padding: 0 !important; }
</style>